import * as React from "react";
import { forwardRef } from "react";
const SvgLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 16, height: 16, fill: "white", fillOpacity: 0.01 }), /* @__PURE__ */ React.createElement("path", { d: "M7.99984 13.3333L8.93984 12.3933L5.21984 8.66667H13.3332V7.33334H5.21984L8.9465 3.61334L7.99984 2.66667L2.6665 8L7.99984 13.3333Z", fill: "#352D43" }));
const ForwardRef = forwardRef(SvgLeft);
export default ForwardRef;
